import { Editor } from "@monaco-editor/react";
import { forwardRef } from "react";
import FormInputContainer from "./form-input-container";

type FormCodeEditorProps = {
  language: "css" | "html";
  label: string;
  description?: string;
  value: string;
  onChange: (value: string | undefined) => void;
  disabled?: boolean | string;
};

const FormCodeEditor = forwardRef(
  ({
    language,
    label,
    description,
    value,
    onChange,
    disabled,
  }: FormCodeEditorProps) => {
    return (
      <FormInputContainer
        label={label}
        description={description}
        disabled={disabled}
      >
        <Editor
          language={language}
          value={value}
          onChange={onChange}
          className="rounded-lg shadow-lg overflow-hidden"
          theme="vs-dark"
          height={150}
        />
      </FormInputContainer>
    );
  },
);

FormCodeEditor.displayName = "FormCodeEditor";

export default FormCodeEditor;
